(function ($) {
    'use strict';

    var classList = require('./classList');

    // Links to other sites need to be catched en have to show a popup before they
    // leave
    function block_external_links() {
        var popup         = document.querySelector('#exit-popup');
        var popup_close  = document.querySelectorAll('#exit-popup .close');
        var popup_leave = document.querySelectorAll('#exit-popup .leave-page');
        var anchors       = document.querySelectorAll('a');

        Array.prototype.forEach.call(anchors, function (item) {
            if(
                !is_internal_link(item.href) &&
                item.href.indexOf('mailto:') === -1 &&
                item.href.indexOf('tel:') === -1
            ){
                item.removeEventListener('click', openPopup, false);
                item.addEventListener('click', openPopup, false);
            }
        });
        Array.prototype.forEach.call(popup_close, function (item) {
            item.addEventListener('click', function (ev) {
                ev.preventDefault();

                popup.querySelector('.leave-page').href = '#';

                classList.remove(popup, 'open');
            });
        });
        Array.prototype.forEach.call(popup_leave, function (item) {
            item.addEventListener('click', function (ev) {
                classList.remove(popup, 'open');
            });
        });
    }
    function is_internal_link(link) {
        var isInternal = false;
        var localhost      =  window.location.host.replace('www.',''); // strip www if present
        var expression = '^https?:\/\/(www\.)?'; // check for all https http www non-www combinations

        var whitelist_domains = [
            localhost,
            'instanyl.nl',
            'alofisel.nl',
            'fistels-en-crohn.nl',
            'entyvio.nl',
            'wijbehandelenibd.nl',
            'wijhebbencolitis.nl',
            'wijhebbencrohn.nl',
            'takeda.nl',
            'takeda.com',
            'takedaclinicaltrials.com',
            'cases.meduniverse.com',
            'takedavideohosting.com'
        ];

        Array.prototype.forEach.call(whitelist_domains, function (domain) {
            if(link.match(new RegExp(expression + domain))) {
                isInternal = true;
            }
        });

        return isInternal;
    }
    function openPopup(ev) {
        ev.preventDefault();
        var popup = document.querySelector('#exit-popup');

        // Add url to the button of the popup.
        popup.querySelector('.leave-page').href = this.href;
        // Open popup here
        classList.add(popup, 'open');
    }
    module.exports = block_external_links;

}(jQuery));
